import React from "react";
import styled from 'styled-components';

import { Button } from "./Button";
import { HeroParagraph } from "../theme/typography";

const StyledSupportBlock = styled.section`
	background: ${(props) => props.theme.colors.yellow6};
	color: ${(props) => props.theme.colors.neutral2};
`;

const ContentContainer = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding: 1.5rem;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		align-items: flex-end;
		flex-direction: row;
		justify-content: center;
	}

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		gap: 3rem;
		padding: 3rem;
	}
`;

const SupportOption = styled.div`
	box-sizing: border-box;
	flex: 1;
	max-width: 32rem;
`;

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-top: 2rem;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		display: flex;
	}
`;

const Heading = styled.h3`
	${(props) => props.theme.typography.headingL};
	margin: 1.5rem auto;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.sixth}) {
		${(props) => props.theme.typography.headingXL};
	}
`;

const FlexButton = styled(Button)`
	flex: 0 0 auto;
	background-color: ${(props) => props.theme.colors.neutral1};
`;

export class SupportBlock extends React.Component {

	render() {
		return (
			<StyledSupportBlock id="support">
				<ContentContainer>
					<SupportOption>
						<Heading>Interested in supporting Tressym?</Heading>
						<HeroParagraph>The easiest way to support us is to buy things in the Tressym shop. Or just tell your friends about us!</HeroParagraph>
						<HeroParagraph>You can also buy me a pack of props through Ko-Fi:</HeroParagraph>
						<ButtonContainer>
							<FlexButton label="Support on Ko-Fi" link="https://ko-fi.com/edwardsch"/>
						</ButtonContainer>
					</SupportOption>
				</ContentContainer>
			</StyledSupportBlock>
		);
	}
}